import './App.css';
import AppView from './pages/AppView';

//React App ~ Main Page Loader.
function App() 
{
  return (
    <div>
      <AppView />
    </div>
  );
}

export default App;
